import React, {useEffect, useState} from 'react';
import './CSS/Preferences.css';
import {useNavigate} from "react-router-dom";

const Preferences: React.FC = () => {
    const navigate = useNavigate(); // Hook for navigation


    const [userEmail, setEmail] = useState<string | null>(null);

    useEffect(() => {
        const storedEmail = localStorage.getItem('userEmail');

        setEmail(storedEmail);
    }, []);

    const submitPreferences = () => {
        navigate('/account/profile');
    };

    return (
        <div className="preferences-container">
            <h1 className="preferences-title">Update Your VIZEdi Email Preferences</h1>
            <p className="preferences-subtitle">
                Please adjust your email preferences below, and we will refine our updates accordingly to bring you
                the best possible experience that we can.
            </p>

            <div className="preferences-form">
                <p className="preferences-email">Preferences for <b>{userEmail || 'No Email Available'}</b></p>
                <div className="preference-item">
                    <label>
                        <input type="checkbox"/>
                        Weekly Progress Reports
                    </label>
                    <p className="preference-description">
                        Get a weekly report with statistics and insights on how you are doing.
                    </p>
                </div>

                <div className="preference-item">
                    <label>
                        <input type="checkbox"/>
                        Product Updates
                    </label>
                    <p className="preference-description">
                        Important info on new features and products. We may ask for your feedback on occasion.
                    </p>
                </div>

                <div className="preference-button">
                    <button className="preferences-submit-btn" onClick={submitPreferences}>Update preferences</button>
                </div>


            </div>
        </div>
    );
};

export default Preferences;
